import React from 'react';
import { motion } from 'framer-motion';
import { Brain, AlertTriangle, Clock, HeartCrack } from 'lucide-react';
const problems = [{
  icon: <AlertTriangle className="w-8 h-8 text-red-500" data-id="element-200" />,
  title: 'Miedo a equivocarte',
  desc: 'Esa sensación de vacío en el estómago cuando llega un politraumatizado y no estás 100% seguro de qué hacer primero.'
}, {
  icon: <Brain className="w-8 h-8 text-red-500" data-id="element-201" />,
  title: 'Síndrome del impostor',
  desc: 'Sentir que todos saben más que vos y que en cualquier momento se van a dar cuenta de que te faltan conocimientos prácticos.'
}, {
  icon: <Clock className="w-8 h-8 text-red-500" data-id="element-202" />,
  title: 'Cero tiempo para estudiar',
  desc: 'Salís de una guardia de 24hs destruido. Agarrar el Campbell o el Rockwood es imposible cuando apenas podés mantener los ojos abiertos.'
}, {
  icon: <HeartCrack className="w-8 h-8 text-red-500" data-id="element-203" />,
  title: 'Sobrecarga emocional',
  desc: 'El estrés constante de tomar decisiones rápidas sin el respaldo inmediato de un superior, rogando no cometer un error grave.'
}];
export function Problems() {
  return <section className="py-20 bg-red-50 text-navy-900 px-4" data-id="element-204">
      <div className="max-w-5xl mx-auto" data-id="element-205">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-12" data-id="element-206">
          <h2 className="text-3xl md:text-4xl font-bold mb-4 text-red-900" data-id="element-207">
            Sabemos exactamente por lo que estás pasando.
          </h2>
          <p className="text-lg text-red-800/70 max-w-3xl mx-auto" data-id="element-208">
            El primer año de residencia es brutal. La teoría de la facultad no
            te prepara para la realidad de una guardia a las 3 AM.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-5 mb-12" data-id="element-209">
          {problems.map((p, i) => <motion.div key={i} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: i * 0.1
        }} className="bg-white border border-red-200 p-6 rounded-2xl flex gap-4 shadow-sm hover:shadow-md transition-shadow" data-id="element-210">
              <div className="shrink-0 bg-red-100 p-3 rounded-xl h-fit" data-id="element-211">
                {p.icon}
              </div>
              <div data-id="element-212">
                <h3 className="text-xl font-bold mb-2 text-red-900" data-id="element-213">
                  {p.title}
                </h3>
                <p className="text-red-800/80 text-sm leading-relaxed" data-id="element-214">
                  {p.desc}
                </p>
              </div>
            </motion.div>)}
        </div>

        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="text-center" data-id="element-215">
          <h3 className="text-2xl md:text-3xl font-bold text-navy-900 mb-2" data-id="element-216">
            Para eso diseñamos esto:
          </h3>
          <div className="w-24 h-1 bg-navy-800 mx-auto rounded-full mt-4" data-id="element-217"></div>
        </motion.div>
      </div>
    </section>;
}